export enum AudienceStatusEnum {
  DRAFT = 1,
  LIVE = 2,
  PAUSED = 3,
  CLOSED = 4
}
